import React from 'react'
import * as GrCheckbox from "react-icons/gr";
import './Trellosidebar.css'


const Boardwajahat = () => {
  return (
    <div className='d-flexdiv'>
        <div className = 'diviconsdiv'>
            <GrCheckbox.GrCheckbox/>
            </div>
        <p className='divcolormem'>Settings
         </p>
        
        
    </div>
  )
}

export default Boardwajahat